import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const AddressAutocomplete = ({
  value,
  onChange,
  onPlaceChanged,
  placeholder = '输入地址，从下拉列表选择',
  className = '',
}) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (!window.google || !window.google.maps) {
      console.warn('Google Maps API not loaded');
      return;
    }

    if (inputRef.current && !autocompleteRef.current) {
      autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
        types: ['address'],
        componentRestrictions: { country: 'my' }, // 限制马来西亚，可按需调整
      });

      autocompleteRef.current.addListener('place_changed', () => {
        const place = autocompleteRef.current.getPlace();
        if (place && place.formatted_address) {
          onChange(place.formatted_address);
          if (onPlaceChanged) onPlaceChanged(place);
        }
      });
    }
  }, [onChange, onPlaceChanged]);

  return (
    <input
      ref={inputRef}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={className}
    />
  );
};

AddressAutocomplete.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onPlaceChanged: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default AddressAutocomplete;